import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Input } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";

const { TextArea: DesignTextArea } = Input;
const left = css({ textAlign: 'left' });
const TextArea = props => {
  const { element } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { width, horizontalAlign = 'left' } = settings;

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-textarea', left)}
            {...formSettings}
          >
            <DesignTextArea style={{ width: width.value }} {...formItemSettings} className={className} />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default TextArea;
